import { InjectionToken } from "@angular/core";
import { TranslationConfig } from "i18n";

export const TRANSLATION_CONFIG = new InjectionToken<TranslationConfig>('TRANSLATION_CONFIG');